import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;
const BASE_SAVERS = 'https://saversapidev.azure-api.net/D365nVisionService/api';

export const getBranchesbyCustomerEffect = (custId) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetBranchsByCustomer?customerKey=${custId}`,
    method: 'get',
  });
};
export const getUserTypeEffect = (userType) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetAllSaversUserType?userType=${userType}`,
    method: 'get',
  });
};
export const getTrailersListEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetAllTrailer`,
    method: 'get',
    params: {
      orderByColumn: 'createdon',
      orderBySort: 'DESC',
      ...params,
    },
  });
};
export const getSupplierListEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetSaversSupplier`,
    method: 'get',
  });
};
export const getTrailerDetailsEffect = (trailerId) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetAllTrailer?trailerId=${trailerId}`,
    method: 'get',
  });
};
export const getTrailerListByYardEffect = (yardID) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetAllTrailer?yardID=${yardID}`,
    method: 'get',
  });
};
export const getUserRelationEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetUserRelation`,
    method: 'get',
  });
};
export const getTrailerRequestsEffect = ({ pageNo }) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerRequest`,
    method: 'get',
    params: {
      PageSize: 10,
      PageNumber: pageNo || 1,
      orderByColumn: 'createdon',
      orderBySort: 'DESC',
    },
  });
};
export const getTrailerRequestByIDEffect = (requestID) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerRequestById?trailerRequestId=${requestID}`,
    method: 'get',
  });
};
export const getTrailerRequestByTrailerIDEffect = (trailerID) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerRequestById?trailerID=${trailerID}`,
    method: 'get',
  });
};
export const getTrailerRequestByUserIDEffect = (userID, pageNo) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerRequest`,
    method: 'get',
    params: {
      userId: userID,
      PageSize: 10,
      PageNumber: pageNo || 1,
      orderByColumn: 'createdon',
      orderBySort: 'DESC',
    },
  });
};
export const getTrailerSizeEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerSize`,
    method: 'get',
  });
};
export const getTrailerCommodityEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerCommodities`,
    method: 'get',
  });
};
export const getTrailerConditionStatusEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerStatus`,
    method: 'get',
  });
};
export const getTrailerRequestStatusEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerRequestStatus`,
    method: 'get',
  });
};
export const getUnitSizesEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetUnitSizes`,
    method: 'get',
  });
};
export const getYardsEffect = () => {
  return axiosInstance.request({ url: `${API.SAVERS}/GetYard`, method: 'get' });
};
export const getRentalCompaniesEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetUnitRentalCompanies`,
    method: 'get',
  });
};
export const saveTrailerRequest = (data) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/SaveTrailerRequest`,
    method: 'post',
    data: JSON.stringify(data).replaceAll('[{', '{').replaceAll('}]', '}'),
    headers: { 'Content-Type': 'application/json' },
  });
};
export const saveTrailerMovement = (data) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/SaveTrailerMovement`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};
export const sendDataToD365 = (data) => {
  return axiosInstance.request({
    url: `${BASE_SAVERS}/nVisionD365/v1`,
    method: 'post',
    data: JSON.stringify(data[0]),
    headers: { 'Content-Type': 'application/json', 'Ocp-Apim-Subscription-Key': '85b692a6636e41a6b751c05d41424f22' },
  });
};
export const saveShipmentData = (data) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/CreateSaversShipments`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};
export const generateShipmentNoEffect = (userID) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GenerateShipmentNumber?UserId=${userID}`,
    method: 'get',
  });
};
export const getBranchDetails = (branchKey) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentBranchAddress?BranchKey=${branchKey}`,
    method: 'get',
  });
};
export const getAllSaversCarriers = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetSaversCarrier`,
    method: 'get',
  });
};
export const getAllStatusEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetStatus`,
    method: 'get',
  });
};
export const getSupplyZoneEffect = (queryString = '') => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetAllSupplyZone${queryString ? queryString : ''}`,
    method: 'get',
  });
};
export const getAllLocationsEffect = (queryString = '') => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetAllLocation${queryString ? queryString : ''}`,
    method: 'get',
  });
};
export const getAllSupplyLocationIDEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentBranches`,
    method: 'get',
  });
};
export const getAllSupplyRegionEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetAllRegion`,
    method: 'get',
  });
};

export const getAllSupplyRscmEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetAllSaversUserType?userType=RSCM`,
    method: 'get',
  });
};

export const saveSupplyZone = (data) => {
  const updatedData = data.length === 1 ? data[0] : null;

  if (!updatedData) {
    throw new Error('Invalid data format. Expected an array with exactly one element.');
  }

  return axiosInstance.request({
    url: `${API.SAVERS}/SaveSupplyZone`,
    method: 'post',
    data: JSON.stringify(updatedData),
    headers: { 'Content-Type': 'application/json' },
  });
};

export const SaversShipmentTenderProcess = (shipmentKey) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/SaversShipmentTenderProcess?shipmentKey=`,
    method: 'post',
    params: shipmentKey,
  });
};

export const getAllFreightCommodityIdEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GeFreightCommodity`,
    method: 'get',
  });
};

export const getAllUnitRentalCompanyIdEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetUnitRentalCompanies`,
    method: 'get',
  });
};

export const getAllNewUnitSizeIdEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetUnitSizes`,
    method: 'get',
  });
};

export const getAllYardEffect = () => {
  return axiosInstance.request({ url: `${API.SAVERS}/GetYard`, method: 'get' });
};

export const getAllTrailerStatusEffect = () => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerStatus`,
    method: 'get',
  });
};

export const getRatingPreferenceEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAllRatingPreferences`,
    method: 'get',
  });
};

export const getEquipmentTypesEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAllEquipmentTypes`,
    method: 'get',
  });
};

export const getServiceLevelEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentServiceLevel?CustomerKey=6067&PageSize=10000&PageNumber=1`,
    method: 'get',
  });
};

export const getAccessorialsDetailsEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentAccessorialsForCustomer?shipmentKey=0`,
    method: 'get',
  });
};

export const saveTrailer = (data) => {
  const saveData = data.length === 1 ? data[0] : null;

  if (!saveData) {
    throw new Error('Invalid data format. Expected an array with exactly one element.');
  }

  return axiosInstance.request({
    url: `${API.SAVERS}/SaveTrailer`,
    method: 'post',
    data: JSON.stringify(saveData),
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateTrailerStatus = (data) => {
  const saveData = data.length === 1 ? data[0] : null;

  if (!saveData) {
    throw new Error('Invalid data format. Expected an array with exactly one element.');
  }

  return axiosInstance.request({
    url: `${API.SAVERS}/UpdateTrailerStatus`,
    method: 'post',
    data: JSON.stringify(saveData),
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateTrailerNote = (data) => {
  const saveData = data.length === 1 ? data[0] : null;

  if (!saveData) {
    throw new Error('Invalid data format. Expected an array with exactly one element.');
  }

  return axiosInstance.request({
    url: `${API.SAVERS}/UpdateTrailerCondition`,
    method: 'put',
    data: JSON.stringify(saveData),
    headers: { 'Content-Type': 'application/json' },
  });
};

let getShipmentListEffectCancelToken = () => {};
export const getShipmentListEffect = (data) => {
  getShipmentListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SAVERS}/GetTrailerShipment`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getShipmentListEffectCancelToken = c;
    }),
  });
};

let updateShipmentStatusEffectCancelToken = () => {};
export const updateShipmentStatusEffect = (data) => {
  updateShipmentStatusEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SAVERS}/UpdateTrailerRequestStatus`,
    method: 'post',
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      updateShipmentStatusEffectCancelToken = c;
    }),
  });
};
